<template>
	<div class="dropdown" v-show="sharedStore.locales.length > 1">
		<button class="btn btn-sm btn-light dropdown-toggle border" type="button"id="dropdownMenuButton" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
			{{ $t(`js.language_name`) }}
		</button>
		<div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
			<a v-for="locale in sharedStore.locales" :key="`lang_${locale}`" class="dropdown-item" href="#" @click="sharedStore.setLocale(locale)" >
				{{ $t(`js.language_name`, {}, { locale: locale }) }}
			</a>
		</div>
	</div>
</template>

<script setup lang="ts">
import { useSharedStore } from "@/entrypoints/stores/shared";
const sharedStore = useSharedStore();
</script>
